<template>
  <div class="auth0-callback">
    <div class="auth0-callback__container">
      <div class="auth0-callback__content">
        <img src="@/assets/logo.png" class="auth0-callback__logo" alt="logo" />

        <div class="auth0-callback__loader">
          <q-spinner color="primary" size="3em" />
        </div>

        <h2 class="auth0-callback__title">{{ $t('PROCESSING_LOGIN') }}</h2>
        <p class="auth0-callback__subtitle">{{ $t('PLEASE_WAIT') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthApi } from '@api/index';
export default {
  name: 'Auth0Callback',

  async mounted() {
    await this.handleAuthCallback();
  },

  methods: {
    async handleAuthCallback() {
      // For authorization code flow, the code is in query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        console.error('Auth0 login error:', error);
        // Redirect to login page with error
        this.$router.push({
          path: '/auth/login',
          query: { error: 'Authentication failed. Please try again.' }
        });
        return;
      }

      if (!code) {
        console.error('No authorization code in callback');
        this.$router.push('/auth/login');
        return;
      }

      const location = await AuthApi.getLocationFromIP();
      const additionalInformations = {
        country: location.countryCode.toUpperCase(),
        main_location: location.formattedAddress
      };

      // Send the code to your backend to exchange for tokens
      AuthApi.handleAuthCallback(code, additionalInformations)
        .then(() => {
          // Redirect to the intended destination or home
          const redirectUrl = state || '/';
          this.$router.push(redirectUrl);
        })
        .catch(error => {
          console.error('Error exchanging code for token:', error);
          this.$router.push({
            path: '/auth/login',
            query: { error: 'Authentication failed. Please try again.' }
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.auth0-callback {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--main-bg-color);

  &__container {
    width: 35%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1200px) {
      width: 40%;
    }

    @media (max-width: 768px) {
      width: 90%;
    }
  }

  &__content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    background-color: var(--secondary-bg-color);
    padding: 48px 32px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    text-align: center;
  }

  &__logo {
    max-width: 140px;
    height: auto;
    margin-bottom: 16px;
  }

  &__loader {
    margin: 20px 0;
  }

  &__title {
    @include mona-sans-font($size: 24px, $bolded: true, $color: var(--main-text-color));
    margin: 0;
  }

  &__subtitle {
    @include inter-font($size: 16px, $color: var(--secondary-text-color));
    margin: 0;
  }
}
</style>
